<template>
  <div>
    <div
      class="w-100 p-2"
      style="background:#EBF1EE; border-top-left-radius:5px; border-top-right-radius:5px"
    >
      <div class="d-inline">
        <div
          class="badge badge-pill px-4 py-2 mr-2"
          :style="{
            background: `${secondaryColor(item.caatFromColor)}`,
            border: `1px solid ${item.caatFromColor}`,
          }"
        >
          <div class="d-flex align-items-center">
            <div class="mr-2">
              <i
                class="fas fa-map-marker-alt"
                :style="{
                  color: item.caatFromColor,
                }"
              ></i>
            </div>
            <span class="font-weight-bold font-12 text-capitalize text-dark">
              {{ item.caatFrom }}
            </span>
          </div>
        </div>

        <i style="color:#3F5B60" class="far fa-chevron-circle-right"></i>
        <div
          class="badge badge-pill px-4 py-2 ml-2"
          :style="{
            background: `${secondaryColor(item.caatToColor)}`,
            border: `1px solid ${item.caatToColor}`,
          }"
        >
          <div class="d-flex align-items-center">
            <div class="mr-2">
              <i
                class="fas fa-map-marker-alt"
                :style="{
                  color: item.caatToColor,
                }"
              ></i>
            </div>
            <span class="font-weight-bold font-12 text-capitalize text-dark">
              {{ item.caatTo }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <custom-callout
      class="mb-3 custom-callout"
      :opened="isPanelOpen"
      controlled
      :border-color="item.statusColor"
      @click:open="onToggle()"
    >
      <div class="row py-3">
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Estatus:
          </div>
          <div class="color-black font-16 font-weight-normal">
            <custom-balloon
              :background-color="item.statusColor"
              class="mt-2"
              :text="item.statusName"
              dot
            />
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Nombre de Equipo:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.equipmentName | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Código de Equipo:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.equipmentCode | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Número de Solicitud:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.requestCode | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Fecha de Solicitud:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.requestDate | date }}
          </div>
        </div>
        <div class="col">
          <drop-down
            always-show-dropdown
            :items="actionItems"
            class="float-md-right mr-5"
          />
        </div>
      </div>
      <template #edition>
        <div v-if="showAcceptance || showRejection || showSendToRoute">
          <div v-if="showAcceptance">
            <acceptance :item="item" @close="onToggle" @refresh="refresh" />
          </div>
          <div v-else-if="showRejection">
            <rejection :item="item" @close="onToggle" @refresh="refresh" />
          </div>
          <div v-else-if="showSendToRoute">
            <send-to-route :item="item" @close="onToggle" @refresh="refresh" />
          </div>
        </div>

        <div v-else class="bg-gray-light p-2">
          <div class="bg-white p-2 rounded">
            <custom-tab
              content-class="mt-3"
              nav-class="nav-vue-underline"
              no-nav-style
              :default-active-tab="activeTab"
              @input="onChangeTab"
            >
              <custom-tab-item
                class="px-4"
                title="Información Adicional"
                :active="isAdditionalInfo"
              >
                <additional-info :item="additionalInfo" />
              </custom-tab-item>
              <custom-tab-item
                class="px-4"
                title="Información de Solicitud"
                :active="isRequestInfo"
              >
                <request-info :item="currentTransfer" />
              </custom-tab-item>
              <custom-tab-item
                title="Historial de Solicitud"
                :active="isRequestHistory"
                v-if="item.hasLog"
              >
                <div v-if="hasLog">
                  <div v-for="(item, idx) in logItems" :key="idx">
                    <timeline-item :date="item.createdDate" :key="idx">
                      <div class="row w-100">
                        <div class="col-12 col-lg-2">
                          <label
                            class="color-secondary-6 font-14 font-weight-normal mr-2"
                          >
                            Estatus de la Solicitud:
                          </label>
                          <custom-balloon
                            :background-color="item.statusColor"
                            :text="item.statusName"
                            dot
                          />
                        </div>
                        <div class="col-12 col-lg-3">
                          <label
                            class="color-secondary-6 font-14 font-weight-normal mr-2"
                          >
                            Número de Solicitud:
                          </label>
                          <p>{{ item.requestCode }}</p>
                        </div>
                        <div class="col-12 col-lg-2">
                          <label
                            class="color-secondary-6 font-14 font-weight-normal mr-2"
                          >
                            CAAT a Transferir:
                          </label>
                          <p>{{ item.caatTo }}</p>
                        </div>
                        <div class="col-12 col-lg-2">
                          <label
                            class="color-secondary-6 font-14 font-weight-normal mr-2"
                          >
                            Fecha de Solicitud:
                          </label>
                          <p>{{ item.requestDate | date }}</p>
                        </div>
                        <div class="col-12 col-lg-3">
                          <label
                            class="color-secondary-6 font-14 font-weight-normal mr-2"
                          >
                            Sometido por:
                          </label>
                          <p>{{ item.requestBy }}</p>
                        </div>
                      </div>
                      <div class="row w-100">
                        <div class="col-12 col-lg-2">
                          <label
                            class="color-secondary-6 font-14 font-weight-normal mr-2"
                          >
                            Fecha de Envío:
                          </label>
                          <p>{{ item.sendDate | date }}</p>
                        </div>
                        <div class="col-12 col-lg-3">
                          <label
                            class="color-secondary-6 font-14 font-weight-normal mr-2"
                          >
                            Asignado a:
                          </label>
                          <p>{{ item.assigned | empty }}</p>
                        </div>
                        <div class="col-12 col-lg-2">
                          <label
                            class="color-secondary-6 font-14 font-weight-normal mr-2"
                          >
                            Fecha de Transferencia:
                          </label>
                          <p>{{ item.transferDate | date }}</p>
                        </div>
                        <div class="col-12 col-lg-2">
                          <label
                            class="color-secondary-6 font-14 font-weight-normal mr-2"
                          >
                            Comentario:
                          </label>
                          <p>{{ item.comment | empty }}</p>
                        </div>
                      </div>
                    </timeline-item>
                  </div>
                  <div class="row my-4">
                    <div class="col text-center">
                      <action-button
                        v-if="showMore"
                        variant="outline-success custom-view-more actionButton"
                        i="fas fa-chevron-down"
                        @click="handlerMore"
                      >
                        Ver más
                      </action-button>
                    </div>
                  </div>
                </div>
                <custom-result-not-found
                  v-else
                  text="No hay Información Disponible."
                />
              </custom-tab-item>
            </custom-tab>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import { CustomTab, CustomTabItem } from 'custom-tabs';
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import mixAlert from '@/mixins/alert.mixin';
import TransferStatuses from '@/utils/constants/peiAtServiceTransferStatus';

import Acceptance from './Acceptance.vue';
import Rejection from './Rejection.vue';
import SendToRoute from './SendToRoute.vue';

const TEMPLATE_TAB_INDEX = {
  ACCEPTANCE: 1,
  REJECTION: 2,
  SEND_TO_ROUTE: 3,
};
import RequestInfo from './tabs/RequestInfo.vue';
import inventoryService from '@/services/api/inventorycatalog.api';
import AdditionalInfo from './tabs/AdditionalInfo.vue';
import documentService from '@/services/api/document.api.js';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';
import TimelineItem from '@quisit/timeline-item';

const TABS = {
  ADDITIONAL_INFO: 0,
  REQUEST_INFO: 1,
  REQUEST_HISTORY: 2,
};

export default {
  name: 'InventoryTransferResultRow',
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
    Acceptance,
    Rejection,
    SendToRoute,
    CustomTab,
    CustomTabItem,
    RequestInfo,
    AdditionalInfo,
    TimelineItem,
    CustomResultNotFound,
    ActionButton,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedTemplateTabIndex: null,
      isOpen: false,
      currentTransfer: {},
      additionalInfo: {},
      log: [],
      activeTab: TABS.ADDITIONAL_INFO,
      logCount: 5,
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    actionItems() {
      return [
        {
          name: 'Información Adicional',
          icon: 'fas fa-info-circle text-green',
          click: () => {
            this.selectedTemplateTabIndex = null;
            this.open();
            this.activeTab = TABS.ADDITIONAL_INFO;
          },
        },
        {
          name: 'Ver Solicitud de Tranferencia',
          icon: 'fas fa-file-search text-green',
          click: () => {
            this.selectedTemplateTabIndex = null;
            this.open();
            this.activeTab = TABS.REQUEST_INFO;
          },
        },
        {
          name: 'Historial de Solicitud',
          icon: 'fas fa-clock-rotate-left text-green',
          visible: this.item.hasLog,
          click: () => {
            this.selectedTemplateTabIndex = null;
            this.open();
            this.activeTab = TABS.REQUEST_HISTORY;
          },
          border: 'bottom',
        },
        {
          name: 'Aceptar',
          icon: 'fas fa-check-circle text-green',
          visible:
            this.userHasPermissions(
              'technologyassistance.equipmenttranferrequesthandling.approve'
            ) && this.item.statusId === TransferStatuses.Submitted,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.ACCEPTANCE;
            this.open();
          },
        },
        {
          name: 'Rechazar',
          icon: 'fas fa-times-circle text-danger',
          visible:
            this.userHasPermissions(
              'technologyassistance.equipmenttranferrequesthandling.reject'
            ) && this.item.statusId === TransferStatuses.Submitted,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.REJECTION;
            this.open();
          },
        },
        {
          name: 'Enviar a ruta',
          icon: 'fas fa-paper-plane text-success',
          visible: this.item.statusId === TransferStatuses.Approved,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.SEND_TO_ROUTE;
            this.open();
          },
        },
      ];
    },
    showAcceptance() {
      return this.selectedTemplateTabIndex === TEMPLATE_TAB_INDEX.ACCEPTANCE;
    },
    showRejection() {
      return this.selectedTemplateTabIndex === TEMPLATE_TAB_INDEX.REJECTION;
    },
    showSendToRoute() {
      return this.selectedTemplateTabIndex === TEMPLATE_TAB_INDEX.SEND_TO_ROUTE;
    },
    isAdditionalInfo() {
      return this.activeTab === TABS.ADDITIONAL_INFO;
    },
    isRequestInfo() {
      return this.activeTab === TABS.REQUEST_INFO;
    },
    isRequestHistory() {
      return this.activeTab === TABS.REQUEST_HISTORY;
    },
    isPanelOpen() {
      return this.item.isOpen;
    },
    secondaryColor() {
      return (color) => {
        //hex to rgb
        let c = color.substring(1).split('');
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return (
          'rgba(' +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
          ', 0.15)'
        );
      };
    },
    logItems() {
      const items = this.log
        .map((item) => {
          return {
            ...item,
            date: item.requestDate,
          };
        })
        .slice(0, this.logCount);
      return items;
    },
    hasLog() {
      return this.log.length > 0;
    },
    showMore() {
      return this.log.length > this.logCount && this.log.length > 5;
    },
  },
  methods: {
    async onToggle() {
      if (this.item.isOpen) {
        this.close();
        return;
      }
      this.selectedTemplateTabIndex = null;
      this.open();
    },
    open() {
      this.isOpen = true;
      this.$emit('open', this.item);
    },
    close() {
      this.isOpen = false;
      this.selectedTemplateTabIndex = null;
      this.$emit('close', this.item);
    },
    refresh() {
      this.$emit('refresh');
    },
    async onChangeTab(key) {
      switch (key) {
        case TABS.ADDITIONAL_INFO:
          await this.getRequestAdditionalInfo();
          break;
        case TABS.REQUEST_INFO:
          await this.getRequestInfo();
          break;
        case TABS.REQUEST_HISTORY:
          await this.getLog();
          break;

        default:
          break;
      }
    },
    async getRequestInfo() {
      const { data } = await inventoryService.getTransferInfo(this.item.id);
      this.currentTransfer = data;
    },
    async getRequestAdditionalInfo() {
      const { data } = await inventoryService.getTransferAdditionalInfo(
        this.item.id
      );
      this.additionalInfo = data;
    },
    async downloadHandler() {
      await documentService
        .downloadFromServer(this.currentTransfer.documentId)
        .catch(() => {
          this.ShowToast(
            'Error',
            'Hubo un error al descargar el documento',
            'error'
          );
        });
    },
    async getLog() {
      const { data } = await inventoryService.getTransferHistory(this.item.id);
      this.log = data;
    },
    handlerMore() {
      this.logCount += 5;
    },
  },
};
</script>
<style lang="scss" scoped>
.gap-y-2 {
  gap: 20px 0px;
}

.bg-white {
  ::v-deep div.bg-secondary-3 {
    background-color: white !important;
  }
}

::v-deep .dot {
  padding: 18px !important;
  margin-bottom: 1px;
}

::v-deep .title-icon {
  padding-bottom: 3px;
}
</style>
